<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>追加認証</HeadingOne>

    <NoticeBox v-if="errors.one_time_password" class="-error _mb-sm-40 _mb-md-60">
      <NoticeHeader>
        <h3 class="heading">以下の内容をご確認ください。</h3>
      </NoticeHeader>
      <NoticeBody>
        <ul>
          <li>ワンタイムパスワードが誤っています。ワンタイムパスワードを再入力してください。</li>
        </ul>
      </NoticeBody>
    </NoticeBox>

    <NoticeBox v-else-if="ngCount" class="-error _mb-sm-40 _mb-md-60">
      <NoticeHeader>
        <h3 class="heading">以下の内容をご確認ください。</h3>
      </NoticeHeader>
      <NoticeBody>
        <ul>
          <li>
            一定回数以上の操作があったため、「戻る」ボタンより暗証番号入力画面から再度お手続きをいただきますようお願いいたします。
          </li>
        </ul>
      </NoticeBody>
    </NoticeBox>

    <ErrorsAlert v-else :errors="errors" class="_mt-md-60 _mt-sm-60"></ErrorsAlert>

    <HeadingTwo class="head-icon">
      ワンタイムパスワード送信
      <router-link
        :to="{ name: 'sv060', hash: '#section_02' }"
        target="_blank"
        @click="trackGtmEvent('【click】ステップ', 'ステップ②')"
      >
        <img src="@/assets/images/mb/common/question.svg" />
      </router-link>
    </HeadingTwo>

    <p>
      <template v-if="hasAuPhone"> {{ userData.phone_au_1 }}-XXXX-{{ userData.phone_au_3 }} </template>
      <template v-else> {{ userData.phone_mobile_1 }}-XXXX-{{ userData.phone_mobile_3 }} </template
      >へワンタイムパスワードを送信しました。届かない場合は、「ワンタイムパスワードを再送する」を押してください。
    </p>
    <section>
      <TableGroup>
        <TableBox class="_mb-10">
          <TableBody>
            <TableRow>
              <TableHeader> ワンタイムパスワード </TableHeader>
              <TableData>
                <InputGroup>
                  <InputgroupAppend>
                    <InputItem
                      id="one_time_password"
                      v-model="inputCode.one_time_password"
                      class="-md"
                      type="password"
                      :maxlength="6"
                    ></InputItem>
                  </InputgroupAppend>
                </InputGroup>
              </TableData>
            </TableRow>
          </TableBody>
        </TableBox>
      </TableGroup>

      <form novalidate @submit.prevent="submitOtpSmsSend">
        <BtngroupDouble class="-margin-lg">
          <template #main>
            <BtnMain class="-main" @click.prevent="submitOtpSmsSend"> ワンタイムパスワードで認証する </BtnMain>
          </template>
          <template #back>
            <BtnBack class="-back -sm" router-name="mb001"> 戻る </BtnBack>
          </template>
        </BtngroupDouble>
      </form>

      <BtngroupSingle class="_mb-md-120 _mb-sm-60">
        <BtnMain class="-normal" :disabled="ngCount ? 'disabled' : null" @click.prevent="reSentOtpSmsSend"
          >ワンタイムパスワードを再送する</BtnMain
        >
      </BtngroupSingle>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { initCredentials } from "@/utils/Auth";
import { getUserDataLambdaInvoke, otpInputLambdaInvoke, otpSmsSendLambdaInvoke } from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage, scrollTop } from "@/utils/Other";

import { trackGtmEvent } from "@/utils/Gtm";

import ErrorsAlert from "@/components/alert/ErrorsAlert";
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import BtngroupDouble from "@/components/button/BtngroupDouble";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import InputGroup from "@/components/input/InputGroup";
import InputgroupAppend from "@/components/input/InputgroupAppend";
import InputItem from "@/components/input/InputItem";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import NoticeBody from "@/components/box/NoticeBody";

export default {
  name: "Mb061",
  components: {
    BtnBack,
    BtnMain,
    BtngroupDouble,
    BtngroupSingle,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    HeadingOne,
    HeadingTwo,
    ErrorsAlert,
    BreadcrumbGroup,
    InputGroup,
    InputgroupAppend,
    InputItem,
    NoticeHeader,
    NoticeBox,
    NoticeBody,
  },
  setup() {
    setMeta({
      title: "追加認証・ワンタイムパスワード入力",
      description: "",
      keywords: "",
    });

    return {
      trackGtmEvent,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "追加認証",
          active: true,
        },
      ],
      errors: {},
      isDisabled: false,
      pageId: this.$route.query.page_id,
      authKind: this.$route.query.auth_kind,
      userData: {
        phone_au_1: "",
        phone_au_2: "",
        phone_au_3: "",
        phone_mobile_1: "",
        phone_mobile_2: "",
        phone_mobile_3: "",
        user_session: "",
      },
      limit: 5,
      otpSmsSend: {
        message: "",
        event: "",
        ng_count: 0,
      },
      inputCode: {
        one_time_password: "",
        auth_kind: this.$route.query.auth_kind,
      },
    };
  },
  computed: {
    hasAuPhone() {
      return this.userData.phone_au_1 && this.userData.phone_au_2 && this.userData.phone_au_3;
    },
    ngCount() {
      return this.otpSmsSend.ng_count >= this.limit;
    },
  },
  mounted() {
    try {
      getUserDataLambdaInvoke().then((res) => {
        for (let key in res) {
          if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
            this.userData[key] = res[key];
          }
        }
      });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    submitOtpSmsSend: function () {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};

        initCredentials()
          .then(() => {
            otpInputLambdaInvoke(this.inputCode)
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else if (Object.keys(this.errors).length === 0) {
                  let resBody = JSON.parse(res.body);
                  for (let key in resBody) {
                    if (Object.prototype.hasOwnProperty.call(this.otpSmsSend, key)) {
                      this.otpSmsSend[key] = resBody[key];
                    }
                  }

                  let pageName = this.pageId.toLowerCase().replace("-", "");
                  this.$router.push({ name: pageName });
                } else {
                  this.$router.push({ name: "SessionTimeOut" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    reSentOtpSmsSend: function () {
      this.otpSmsSend.ng_count++;
      if (this.ngCount) {
        scrollTop();
        return false;
      }

      try {
        this.errors = {};

        initCredentials()
          .then(() => {
            const userData = this.hasAuPhone
              ? {
                  phone_au_1: this.userData.phone_au_1,
                  phone_au_2: this.userData.phone_au_2,
                  phone_au_3: this.userData.phone_au_3,
                }
              : {
                  phone_mobile_1: this.userData.phone_mobile_1,
                  phone_mobile_2: this.userData.phone_mobile_2,
                  phone_mobile_3: this.userData.phone_mobile_3,
                };
            const data = {
              ...userData,
              user_session: this.userData.user_session,
            };
            otpSmsSendLambdaInvoke(data)
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                } else if (Object.keys(this.errors).length === 0) {
                  let resBody = JSON.parse(res.body);
                  for (let key in resBody) {
                    if (Object.prototype.hasOwnProperty.call(this.otpSmsSend, key)) {
                      this.otpSmsSend[key] = resBody[key];
                    }
                  }
                  scrollTop();
                  this.inputCode.one_time_password = '';
                } else {
                  this.$router.push({ name: "SessionTimeOut" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.TableData {
  > .red {
    color: $danger;
    font-weight: bold;
  }
}
.btn-text {
  &:hover {
    text-decoration: underline;
    color: $orange !important;
  }
}
.btn-main.-main,
.btn-main.-normal {
  width: auto;
}
</style>
